/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogColorGradient } from "../../d-dialog-color-gradient";
import { DThemeDarkDialogFitted } from "./d-theme-dark-dialog-fitted";

export class DThemeDarkDialogColorGradient
	extends DThemeDarkDialogFitted
	implements DThemeDialogColorGradient {}
